import React, { memo, useEffect } from 'react';
import { accountActions } from '../types';
import { useFirebase } from '@web/firebase';
export var FBConnector = memo(function (_a) {
    var uid = _a.uid, dispatch = _a.dispatch;
    var instance = useFirebase().instance;
    useEffect(function () {
        if (instance) {
            var unsubscribe_1 = instance.account.doc(uid)
                .onSnapshot(function (doc) {
                console.log("%c SUBSCRIBE TO ACCOUNT (" + uid + ") ", 'background: #0000ff; color: white;');
                dispatch({ type: accountActions.SUCCESS, account: doc.data() });
            });
            return function () {
                console.log('%c UNSUBSCRIBE FROM ACCOUNT ', 'background: #0000ff; color: white;');
                unsubscribe_1();
            };
        }
    }, [instance, uid, dispatch]);
    return (React.createElement(React.Fragment, null));
});
